import { Pkgs } from '../../../types/package'
import { MingcutePackageLine } from '../../../assets/icons/Icons'

interface AddPackageItemProps {
    pack: Pkgs
    handleSelectedPackage: (value: Pkgs) => void;
}

export default function AddPackageItem({ pack, handleSelectedPackage }: AddPackageItemProps) {
    
    const formatted = pack.totalValue

    return (
        <div 
            key={pack.packageID} 
            className={`rounded border-t-8 ${
                pack.isSelected ? 'border-cbColor bg-gray-50' : 'border-cbColor'
            }`}
        >
            <div className='border border-gray-200 flex flex-col p-2.5 space-y-3 rounded-b bg-gray-100'>
                <div className='flex justify-between flex-row-reverse items-center'>
                    <MingcutePackageLine height={25} width={25}/> 
                    <p className='text-sm font-medium truncate'>
                        {pack.packageName}
                    </p>
                </div>
                <div className='grid grid-cols-2 divide-x divide-gray-300'>
                    <div className='space-y-0.5 px-1'>
                        <div className='uppercase text-[10px] text-gray-600 text-center'>CUPS</div>
                        <div className='text-sm font-medium text-center'>{pack.quantity}</div>
                    </div>
                    <div className='space-y-0.5 px-1'>
                        <div className='uppercase text-[10px] text-gray-600 text-center'>Amount</div>
                        <div className='text-sm font-medium text-center'>{`${formatted}`}</div>
                    </div>
                </div>
                <button 
                    className={`text-xs p-1 rounded border transition-all duration-200 ${
                    pack.isSelected
                        ? 'bg-cbColor text-white border-cbColor'
                        : 'border-gray-300 hover:bg-gray-200'
                    }`}
                    onClick={() => handleSelectedPackage(pack)}
                >
                    {pack.isSelected ? 'Unselect Package' : 'Select package'}
                </button>
            </div>
        </div>
    )
}
